// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w5hH","newExpiryDate":"styles_newExpiryDate__1nOE7","footer":"styles_footer__sO9rK"};